import { FC, useMemo } from "react";
import StyledDrawer from "@components/StyledDrawer";
import { Character } from "@models/character";
import FaceSelect from "@components/FaceSelect/FaceSelect";
import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import { formatNameWithRelation } from "@utils/formatting.util";
import TextIconButton from "@components/TextIconButton";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import RepeatOutlinedIcon from "@mui/icons-material/RepeatOutlined";

const CharacterFacesDrawer: FC<{
  onClose: () => void;
  onDelete: () => void;
  onChange: () => void;
  character: Character | null;
}> = ({ onClose, character, onDelete, onChange }) => {
  const { t } = useTranslation();
  const faces = useMemo(() => {
    return character?.faces?.filter((c) => c.photo && c.boundingBox) || [];
  }, [character]);

  return (
    <StyledDrawer onClose={onClose} open={!!character}>
      <Stack
        flexDirection="row"
        justifyContent="space-between"
        gap="16px"
        marginBottom="36px"
      >
        <Typography
          fontSize="32px"
          lineHeight="1"
          fontWeight="700"
          color="#171A1FFF"
        >
          {character?.person ? formatNameWithRelation(character.person) : ""}
        </Typography>

        <Stack flexDirection="row" gap="16px">
          <TextIconButton
            variant="outlined"
            size="small"
            text={t("characters.facesDrawer.changeButton")}
            icon={RepeatOutlinedIcon}
            onClick={onChange}
          />
          <TextIconButton
            variant="outlined"
            size="small"
            color="error"
            text={t("characters.facesDrawer.deleteButton")}
            icon={DeleteOutlineOutlinedIcon}
            onClick={onDelete}
          />
        </Stack>
      </Stack>
      <>
        {!faces?.length ? (
          t("common.noData")
        ) : (
          <Stack gap="8px">
            {faces.map((face) => (
              <FaceSelect
                key={face.id}
                url={face.photo!.fileUrl}
                boundingBox={face.boundingBox!}
              />
            ))}
          </Stack>
        )}
      </>
    </StyledDrawer>
  );
};

export default CharacterFacesDrawer;
